const categories = [
	"Art & Design",
	"Augmented Reality",
	"Auto & Vehicles",
	"Beauty",
	"Books & Reference",
	"Business",
	"Comics",
	"Communications",
	"Dating",
	"Daydream",
	"Education",
	"Entertainment",
	"Events",
	// "Family",
	"Finance",
	"Food & Drink",
	// "Games",
	"Health & Fitness",
	"House & Home",
	"Libraries & Demo",
	"Lifestyle",
	"Maps & Navigation",
	"Medical",
	"Music & Audio",
	"News & Magazines",
	"Parenting",
	"Personalization",
	"Photography",
	"Productivity",
	"Shopping",
	"Social",
	"Sports",
	"Tools",
	"Travel & Local",
	"Video Players & Editors",
	"Wear OS by Google",
	"Weather",
];

export const androidCategories = categories.map(c => {
	return {
		key: c,
		label: c,
		value: c,
	};
});
export const androidSubCategories = [...androidCategories];
